<template>
  <div class="statement-bg">
    <div v-html="statement"></div>
  </div>
  <van-button
    class="button"
    v-if="showBtn"
    round
    type="default"
    color="linear-gradient(to right,#f48260, #e53531)"
    url="http://www.zsnews.cn/app/mobile.html"
    >下载中山+新闻客户端</van-button
  >
</template>

<script>
import { Button } from "vant";
import { computed, ref } from "vue";
import { useStore } from "vuex";
import "@/plugins/bridge.js";

export default {
  name: "StatementPage",
  components: {
    [Button.name]: Button,
  },
  setup() {
    const store = useStore();

    const showBtn = ref(false);

    const userAgentString = navigator.userAgent.toLowerCase();
    if (userAgentString.indexOf("zsrbapp") < 0) {
      showBtn.value = true;
    }

    return {
      showBtn,
      statement: computed(() => store.state.statement),
    };
  },
};
</script>

<style lang="scss" scoped>
.statement-bg {
  width: 85%;
  text-align: left;
  margin: 30px;
  text-align: justify;
}
.button {
  margin-bottom: 50px;
}
</style>
